import styles from "./loader.module.css";
const Loader = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.ldsGrid}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
